var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67341 21.1582C5.97224 21.3779 6.33259 21.3164 6.78962 20.9824L11.5797 17.4756L16.3697 20.9824C16.8179 21.3164 17.1871 21.3779 17.4771 21.1582C17.776 20.9385 17.8463 20.5781 17.6617 20.042L15.7896 14.417L20.6148 10.9453C21.0718 10.6201 21.2301 10.2861 21.1158 9.93457C21.0015 9.5918 20.6763 9.41602 20.1138 9.41602L14.19 9.45117L12.3795 3.7998C12.2037 3.25488 11.94 3 11.5797 3C11.2105 3 10.9556 3.25488 10.7799 3.7998L8.96931 9.45117L3.04548 9.41602C2.47419 9.41602 2.149 9.5918 2.03474 9.93457C1.92048 10.2861 2.08747 10.6201 2.54451 10.9453L7.36091 14.417L5.49763 20.042C5.31306 20.5781 5.38337 20.9385 5.67341 21.1582Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfilled);
export default __webpack_public_path__ + "static/media/Star filled.aad36afc217e03f16fb591a861f24d51.svg";
export { ForwardRef as ReactComponent };